function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.39063 8.62891L7.19922 8.4375C7.14453 8.36458 7.07162 8.32812 6.98047 8.32812C6.88932 8.32812 6.80729 8.36458 6.73438 8.4375L4.46484 10.7344L4.46485 0.453124C4.46485 0.361978 4.4375 0.289061 4.38281 0.234374C4.3099 0.161457 4.22787 0.124999 4.13672 0.124999L3.86328 0.124999C3.77214 0.124999 3.69922 0.161457 3.64453 0.234374C3.57162 0.289061 3.53516 0.361978 3.53516 0.453124L3.53516 10.7344L1.26563 8.4375C1.19271 8.36458 1.11068 8.32812 1.01953 8.32812C0.928386 8.32812 0.85547 8.36458 0.800782 8.4375L0.609376 8.6289C0.536459 8.70182 0.500001 8.77474 0.500001 8.84765C0.500001 8.9388 0.536459 9.02083 0.609376 9.09375L3.78125 12.2656C3.83594 12.3385 3.90885 12.375 4 12.375C4.09115 12.375 4.16406 12.3385 4.21875 12.2656L7.39063 9.09375C7.46354 9.02083 7.5 8.9388 7.5 8.84766C7.5 8.77474 7.46354 8.70182 7.39063 8.62891Z",
  fill: "currentColor"
});

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.e84d1b30.svg";
export { ForwardRef as ReactComponent };